function returnOptions(data) {
  // 定义颜色
  const colorList = [{
    c1: '#FE6D6C',
  },
  {
    c1: '#47D09C',
  },
  {
    c1: '#FF9348',
  },
  {
    c1: '#B177F2',
  },
  {
    c1: '#FDD451',
  },
  ];
  // 重定义套餐销售数量
  const everyResult = data.map((item) => item.packageCount);
  // 重定义套餐名称
  const name = data.map((item) => item.vipCardName);
  return {
    // color: ['#FE6D6C', '#47D09C', '#FF9348', '#B177F2', '#FDD451'],
    title: {
      text: '套餐销售数量',
      textStyle: {
        fontSize: 14
      },
      padding: 10,
      left: '8%',
      top: '2%',
    },
    tooltip: {
      trigger: 'axis',
      backgroundColor: '#FFFFFF',
      textStyle: {
        color: '#B5B5B5',
        fontSize: 14
      },
      axisPointer: {
        type: 'none',
      },
      padding: 10,
      extraCssText: 'box-shadow:0px 6px 24px 6px rgba(37,41,44,0.06);'
    },
    grid: {
      left: '8%',
      right: '13%',
      bottom: '3%',
      containLabel: true
    },
    xAxis: [{
      type: 'category',
      data: name,
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      axisLabel: {
        interval: 0,
        formatter(value) {
          let ret = ''; // 拼接加\n返回的类目项
          const maxLength = 8; // 每项显示文字个数
          const valLength = value.length; // X轴类目项的文字个数
          const rowN = Math.ceil(valLength / maxLength); // 类目项需要换行的行数
          if (rowN > 1) { // 如果类目项的文字大于3,
            for (let i = 0; i < rowN; i++) {
              let temp = ''; // 每次截取的字符串
              const start = i * maxLength; // 开始截取的位置
              const end = start + maxLength; // 结束截取的位置
              // 这里也可以加一个是否是最后一行的判断，但是不加也没有影响，那就不加吧
              temp = `${value.substring(start, end)}\n`;
              ret += temp; // 凭借最终的字符串
            }
            return ret;
          }
          return value;
        },
        fontSize: 13,
        color: '#999'
      }
    }],
    yAxis: [{
      type: 'value',
      nameTextStyle: {
        color: '#b5b5b5',
        align: 'right'
      },
      axisLabel: {
        color: '#b5b5b5',
        fontSize: 15,
        // formatter: (value, index) => {
        //     return value.toFixed(0)
        // }
      },
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      }
    }],
    series: [{
      name: '套餐销售数量',
      type: 'bar',
      barWidth: '20%',
      barCategoryGap: '80%',
      label: {
        show: false
      },
      data: everyResult,
      itemStyle: {
        normal: {
          color(params) {
            return colorList[params.dataIndex].c1;
          }
        }
      }
    }]
  };
}
export const staffC = returnOptions;
